import React, { useState, useEffect } from "react";
import { Table, Space, Button, Tooltip, Spin, Tag } from "antd";
import { BsEye } from "react-icons/bs";
import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../Pagination";
import moment from "moment";
import { getAssignedSurvey } from "../../../api/CommonRequest";
import UnAssignedSurveyList from "./UnAssignedSurveyList";
import { useNavigate } from "react-router-dom";

const SurveyList = ({ pages }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("assigned");

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [unassignedCount, setUnassignedCount] = useState(0);
  const [surveyData, setSurveyData] = useState([]);
  const [activeTab1, setActiveTab1] = useState(""); // Update initial state to 'all'
  const [tabFilter1, setTabFilter1] = useState(""); // Update initial state to 'all'
  // ...
  // const tabs = ['All', 'Live', 'On Hold', 'Cancelled'];
  const tab1 = [
    { label: "All", value: "" },
    { label: "Pending", value: "pending" },
    { label: "Accepted", value: "accepted" },
    { label: "On-going", value: "ongoing" },
    { label: "Completed", value: "completed" },
  ];

  const tabs = [
    { key: "assigned", label: "Assigned Surveys", count: totalItems },
    {
      key: "unassigned",
      label: "Unassigned Surveys",
      count: unassignedCount,
    },
  ];

  // Fetch data from backend
  useEffect(() => {
    const surveyCall = async () => {
      try {
        setLoader(true);
        const { data } = await getAssignedSurvey({
          status: tabFilter1,
          page: currentPage,
          limit: limit,
        });
        if (data?.success) {
          setSurveyData(data?.surveyList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setUnassignedCount(data?.unassignedCount);

          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    surveyCall();
    setSelectedRowKeys([]);
  }, [limit, currentPage, tabFilter1]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(selectedValue); // Update state with the selected value
    setCurrentPage(1);
  };

  const statusColors = {
    pending: "text-yellow-500",
    accepted: "text-blue-500",
    rejected: "text-red-500",
    ongoing: "text-blue-900",
    completed: "text-green-500",
  };
  // Row selection config
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
  };

  const assignedColumns = [
    {
      title: "Survey Name",
      dataIndex: "_id",
      key: "_id",
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
    },
    { title: "State", dataIndex: "state", key: "state" },
    { title: "District", dataIndex: "district", key: "district" },
    { title: "City", dataIndex: "city", key: "city" },

    {
      title: "Status",
      key: "status",
      render: (_, record) => {
        const status = record.assignTo[0]?.status;
        const colorClass = statusColors[status];

        return <Tag className={colorClass}>{status}</Tag>;
      },
    },
    {
      title: "Assigned",
      key: "assigned",
      render: (_, record) => {
        return (
          <p>
            {moment(record.assignTo[0]?.assignedDate).format("DD MMM YYYY")}
          </p>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => moment(date).format("DD MMM YYYY"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View Details">
            <button
              onClick={() => navigate("/survey-single-view", { state: record._id })}
              className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
            >
              <BsEye size={16} />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  if (loader) {
    return <p className="flex justify-center mt-20">Loading........</p>

  }

  return (
    <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
      <div className="p-4">
        {/* Tabs and Add Survey Button */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-6 mt-2">
          <div className="w-full lg:w-auto overflow-x-auto scrollbar-hide py-1">
            <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                  ${activeTab === tab.key
                      ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                      : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                    }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label} <span className="ml-1 opacity-70">({tab.count})</span>
                </button>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-auto">
            <button
              onClick={() => navigate("/survey-create")}
              className="w-full bg-[#1955EB] text-white px-8 h-10 rounded-lg font-bold hover:bg-blue-700 transition-all shadow-lg hover:shadow-blue-200 active:scale-95 text-sm"
            >
              + Add Survey
            </button>
          </div>
        </div>

        <div className="flex justify-between items-center mt-6 mb-6">
          {/* Selected rows info */}
          {activeTab === "assigned" && selectedRowKeys.length > 0 && (
            <div className="flex items-center">
              <span>{`Selected ${selectedRowKeys.length} items`}</span>
              <button
                className="ml-4 text-blue-500"
                onClick={() => setSelectedRowKeys([])}
              >
                Clear selection
              </button>
            </div>
          )}
        </div>

        {/* Survey Table */}
        {activeTab === "assigned" ? (
          <>
            <div className="w-full overflow-x-auto scrollbar-hide py-1 mb-6">
              <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-gray-50/50">
                {tab1.map((tab) => (
                  <button
                    key={tab.value}
                    className={`h-9 px-5 whitespace-nowrap rounded-lg text-xs transition-all duration-200
                      ${activeTab1 === tab.value
                        ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                        : "bg-transparent text-gray-500 hover:bg-white/50 font-medium"
                      }`}
                    onClick={() => {
                      setActiveTab1(tab.value);
                      setTabFilter1(tab.value);
                      setCurrentPage(1);
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="pt-[0px] space-y-10">
              <Table
                columns={assignedColumns}
                rowSelection={rowSelection}
                dataSource={surveyData}
                pagination={false}
                size="small"
                className="custom-table-header w-full overflow-x-auto custom-pagination border border-gray-100 rounded-xl"
                rowKey="_id"
              />

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                limit={limit}
                totalItem={totalItems}
                onPageChange={handlePageChange}
                handleLimit={handleLimit}
              />
            </div>
          </>
        ) : (
          <UnAssignedSurveyList />
        )}
      </div>
    </div>
  );
};

export default SurveyList;
